const isMobile = window.innerWidth <= 480;

export default isMobile;
